import { Path } from "portal/utils/routing";
import { ResponsiveSubnav } from "portal/components/ResponsiveSubnav";
import { useTranslation } from "react-i18next";
import React, { FC } from "react";

interface AtkNavProps {}
export const AtkNav: FC<AtkNavProps> = () => {
  const { t } = useTranslation();

  const pages: { label: string; to: string }[] = [
    {
      label: t("components.map.map"),
      to: `${Path.AUTOTRACTOR}`,
    },
    {
      label: t("models.jobs.job_other"),
      to: `${Path.JOBS}`,
    },
    {
      label: t("models.equipment.equipment"),
      to: `${Path.EQUIPMENT}`,
    },
  ];
  return <ResponsiveSubnav pages={pages} />;
};
